<template>
  <link
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css"
    rel="stylesheet"
  />
  <div v-if="isLoaded">
    <div class="w-screen h-screen grid place-content-center">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isLoaded = ref(false);

onMounted(async () => {
  if (store.getters.publicContainer.id === undefined) {
    await store.dispatch("loadPublicContainerByName", "");
  }

  isLoaded.value = true;
});
</script>
